<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
    
  export let isOpen = false;
  export let closeOnOutsideClick = true;
  
  const handleDialogKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeDialog();
    }
  };

  const closeDialog = () => {
    dispatch('close');
    if (closeOnOutsideClick) {
      isOpen = false;
    }
  };
</script>

{#if isOpen}
<div 
  class="fixed z-20 inset-0 overflow-y-auto bg-black bg-opacity-50" 
  aria-labelledby="modal-title" 
  role="dialog" 
  aria-modal="true"
  on:keydown={handleDialogKeyDown}
  on:click={closeDialog}
>
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div 
      class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-xl"
      on:click={(e) => e.stopPropagation()}
    >
      <slot {isOpen} {closeDialog}></slot>
    </div>
  </div>
</div>
{/if}

